import _ from "lodash";
import {useSelector} from "react-redux";

const useShallowSelector = (selector) => {
    return useSelector(selector, _.shallowEqual);
};

export default useShallowSelector;